<script setup>
import { ref } from 'vue';
import { Modal } from 'uiv';
import { ExclamationCircleIcon } from '@heroicons/vue/24/outline';
import Layout from '@/views/_layouts/main.vue';
import ButtonPrimary from '@/components/buttons/ButtonPrimary.vue';
import LinkNormal from '@/components/links/LinkNormal.vue';

const showModal = ref(true);
function reload() {
  window.location.reload();
}
</script>

<template>
  <Layout>
    <Modal
      v-model="showModal"
      :backdrop="false"
      :footer="false"
      :header="false"
      :keyboard="false"
      class="text-lg leading-tight">
      <h1 class="mb-7 flex items-center text-2xl">
        <ExclamationCircleIcon class="mr-2 h-8 w-8 text-red-700" />
        Something has gone wrong
      </h1>

      <p>
        Our apologies, a server error occured while processing your command. Try reloading the page or
        <LinkNormal
          as="a"
          href="https://www.traxostatus.com/"
          external
          >view our current system status</LinkNormal
        >.
      </p>

      <ButtonPrimary
        type="button"
        class="mt-7 w-full uppercase"
        @click="reload">
        Reload
      </ButtonPrimary>
    </Modal>
  </Layout>
</template>
